import { render } from "./DatePickerWithLabel.vue?vue&type=template&id=45af4ccc"
import script from "./DatePickerWithLabel.vue?vue&type=script&lang=js"
export * from "./DatePickerWithLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__